import { useQuery } from "react-query";
// import axios from "axios";
import { APIRequest, APIRequestForPublic } from "./api.service";

const baseURL = `/Admin/Lookup`;

export const getDepartments = async () => {
  const url = `${baseURL}/Department`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};


export const getEducation = async () => {
  const url = `${baseURL}/Education`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
const getHiringMangers = async () => {
  const url = `${baseURL}/HiringManager`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const getJobType = async () => {
  const url = `${baseURL}/EventType`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};

export const getTitles = async () => {
  const url = `${baseURL}/Title`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const getLanguages = async () => {
  const url = `${baseURL}/Language`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};

// get Role

export const getRole = async () => {
  const url = `${baseURL}/GroupMember/My`;
  const res = await APIRequest({
    url: url,
    method: "get",
  });
  return res;
};
export const getLocations = async () => {
  const url = `${baseURL}/Location`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const getSurveyQuestions = async (eventId) => {
  const url = `${baseURL}/SurveyQuestions?eventId=${eventId}`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};




const getNationalities = async () => {
  const url = `${baseURL}/Nationality`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
const getGradingSystem = async () => {
  const url = `${baseURL}/GradingSystem`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
// Lookup
export const getDataToRightSide = () => {
  const url = `${baseURL}/ApproveJob`;
  const res = APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const getDataToRightSideInApplicantJobs = () => {
  const url = `${baseURL}/PublishedEvent`;
  const res = APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const getDataToRightSideInClosedJobs = () => {
  const url = `${baseURL}/ClosedEvent`;
  const res = APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const getDataToRightSideInAllApplicant = () => {
  const url = `${baseURL}/Applicant`;
  const res = APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};

export const postCreateJob = async (data) => {
  const url = `/Event`;
  const res = await APIRequest({
    url: url,
    method: "post",
    requestBody: data,
  });
  return res;
};


export const postCreateSurvey = async (data) => {
  const url = `${baseURL}/CreateSurvey`;
  const res = await APIRequest({
    url: url,
    method: "post",
    requestBody: data,
  });
  return res;
};
export const postSurveyAnswers = (data) => {
  const url = `${baseURL}/SurveyAnswers`;
  return APIRequestForPublic({
    method: "post",
    url: url,
    requestBody: data,
  });
};

export const getDatatoJobAdvanceSearch = () => {
  const url = `${baseURL}/JobAdvanceSearch`;
  const res = APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};

export const getDatatoApplicantAdvanceSearch = () => {
  const url = `${baseURL}/ApplicantAdvanceSearch`;
  const res = APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const getStageId = () => {
  const url = `${baseURL}/Stage/First`;
  const res = APIRequest({
    url: url,
    method: "get",
  });
  return res;
};
// add lookup
// -------------------- department -----------------
export const addDepartment = (data) => {
  const url = `${baseURL}/Department`;
  return APIRequest({
    method: "post",
    url: url,
    requestBody: data,
  });
};

export const addTitle = (data) => {
  const url = `${baseURL}/Title`;
  return APIRequest({
    method: "post",
    url: url,
    requestBody: data,
  });
};
export const deleteDepartment = (id) => {
  const url = `${baseURL}/Department/${id}`;
  const res = APIRequest({
    url: url,
    method: "delete",
  });
  return res;
};

export const deleteTitle = (id) => {
  const url = `${baseURL}/Title/${id}`;
  const res = APIRequest({
    url: url,
    method: "delete",
  });
  return res;
};
// -------------------- jobtype -----------------
export const addJobtype = (data) => {
  const url = `${baseURL}/EventType`;
  return APIRequest({
    method: "post",
    url: url,
    requestBody: data,
  });
};
export const deleteJobtype = (id) => {
  const url = `${baseURL}/EventType/${id}`;
  const res = APIRequest({
    url: url,
    method: "delete",
  });
  return res;
};
// -------------------- language -----------------
export const addLanguage = (data) => {
  const url = `${baseURL}/Language`;
  return APIRequest({
    method: "post",
    url: url,
    requestBody: data,
  });
};
export const deleteLanguage = (id) => {
  const url = `${baseURL}/Language/${id}`;
  const res = APIRequest({
    url: url,
    method: "delete",
  });
  return res;
};
// -------------------- Locations -----------------
export const addLocations = (data) => {
  const url = `${baseURL}/Location`;
  return APIRequest({
    method: "post",
    url: url,
    requestBody: data,
  });
};
export const deleteLocations = (id) => {
  const url = `${baseURL}/Location/${id}`;
  const res = APIRequest({
    url: url,
    method: "delete",
  });
  return res;
};
// -------------------- Education -----------------
export const addEducation = (data) => {
  const url = `${baseURL}/Education`;
  return APIRequest({
    method: "post",
    url: url,
    requestBody: data,
  });
};
export const deleteEducation = (id) => {
  const url = `${baseURL}/Education/${id}`;
  const res = APIRequest({
    url: url,
    method: "delete",
  });
  return res;
};
// ------------ group member ----------
export const getGroupMember = async () => {
  const url = `${baseURL}/GroupMember`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};
export const addGroupMember = (data) => {
  const url = `${baseURL}/GroupMember`;
  return APIRequest({
    method: "post",
    url: url,
    requestBody: data,
  });
};
export const deleteGroupMember = (id) => {
  const url = `${baseURL}/GroupMember/${id}`;
  const res = APIRequest({
    url: url,
    method: "delete",
  });
  return res;
};
//----------- Countries --------------

export const getCountries = async () => {
  const url = `${baseURL}/Country`;
  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};

// get role

export const getMyRoleAndName = async () => {
  const url = `${baseURL}/MyRole`;

  const res = await APIRequest({
    url: url,
    method: "get",
  });
  return res;
};

export const useDepartmentsQuery = () => {
  return useQuery(["Departments"], getDepartments);
};
export const useEducationQuery = () => {
  return useQuery(["Education"], getEducation);
};
export const useHiringMangersQuery = () => {
  return useQuery(["HiringMangers"], getHiringMangers);
};
export const useJobTypesQuery = () => {
  return useQuery(["EventTypes"], getJobType);
};

export const useTitlesQuery = () => {
  return useQuery(["Titles"], getTitles);
};


export const useLanguagesQuery = () => {
  return useQuery(["Languages"], getLanguages);
};
export const useLocationsQuery = () => {
  return useQuery(["Locations"], getLocations);
};
export const useNationalitiesQuery = () => {
  return useQuery(["Nationalities"], getNationalities);
};
export const useCountriesQuery = () => {
  return useQuery(["Countries"], getCountries);
};
export const useGradingSystemQuery = () => {
  return useQuery(["gradings"], getGradingSystem);
};
export const useGetRoleQuery = () => {
  return useQuery(["role"], getRole, {
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
  });
};
export const useGetRoleAndNameQuery = () => {
  return useQuery(["roleAndName"], getMyRoleAndName, {
    refetchOnWindowFocus: false,
    refetchOnmount: false,
    refetchOnReconnect: false,
    retry: false,
  });
};



export const useSurveys = (eventId,pageSize, pageIndex,searchText) => {
  return useQuery([`Surveys${pageIndex + searchText}`], () =>
    getSurveys(eventId,pageSize, pageIndex,searchText)
  );
};

export const getSurveys = async (eventId,pageSize, pageIndex,searchText) => {
  const url = `${baseURL}/Surveys?eventId=${eventId}&SearchText=${searchText}&pageSize=${pageSize}&pageIdex=${pageIndex}`;

  const res = await APIRequest({
    url: url,
    method: "get",
  });
  return res;
};


export const getSurveyAnswers = async (eventId,applicantId) => {
  const url = `${baseURL}/SurveyAnswers?eventId=${eventId}&applicantId=${applicantId}`;

  const res = await APIRequest({
    url: url,
    method: "get",
  });
  return res;
};

export const getSurvey = (eventId) => {
  const url = `${baseURL}/getSurvey?eventId=${eventId}`;
  const res = APIRequest({
    url: url,
    method: "get",
  });
  return res;
};


export const sendCertificate = async (eventId,applicantId) => {
  const url = `${baseURL}/sendCertificate?eventId=${eventId}&applicantId=${applicantId}`;

  const res = await APIRequestForPublic({
    url: url,
    method: "get",
  });
  return res;
};